module.exports={
lang:'en',
message: {
hello: 'hello',
about: 'about',
welcome: "Welcome"
},
nav: [
{
name: 'Home',
url: '/',
},
{
name: 'About',
url: '/about',
},
{
name: 'Product',
url: '/product',
},
{
name: 'News',
url: '/news',
},
{
name: 'Contact',
url: '/contact',
},
],
title: {
about: `About&nbsp;&nbsp;<em>us</em><span>关于我们</span>`,
product: `Product&nbsp;&nbsp;<em>centre</em><span>产品中心</span>`,
news:`News&nbsp;&nbsp;<em>information</em><span>新闻资讯</span>`,
contact:`Contact&nbsp;&nbsp;<em>us</em><span>联系我们</span>`
},
more:{
value:'More'
},
nav_foot:[
{
name:'About us',
url:'about',
subnavigation:[
{
subname:'Company profile',
id:'',
url:'about'
},
{
subname:'Corporate honor',
id:'honour',
url:'honor'
}
]
},
{
name:'Product centre',
url:'product',
subnavigation:[
{
name:'All',
id:''
}
// {
// subname:'Redispersible of latex powder',
// id:1
// },
// {
// subname:'One-component wood powder',
// id:2
// },
// {
// subname:'Introduction of pure urea-formaldehyde resin powder',
// id:3
// },
// {
// subname:'Environmental protection type urea-formaldehyde resin powder',
// id:4
// }
]
},
{
name:'News information',
url:'news',
subnavigation:[
{
subname:'Company news',
id:'',
url:'company'
},
{
subname:'Industry information',
id:'industry',
url:'industry'
}
]
}
],
addressInfo:{
name:'Contact us',
address:'Address:No.118 Yangjiabuguomu Road,Huzhou City,Zhejiang Province',
hotline:'Information hotline:',
mailbox:'Corporate mail:',
website:'Company website:'
},
contact: {
name: 'HUZHOU JING BAO NEW BUILDING MATERIAL CO.,LTD',
address: 'address：',
hotline: 'tel：',
mailbox: 'email：',
zipcode: 'zipcode：',
cellphone: 'cellphone：',
fax: 'fax：'
},
mteaTitle:{
index:'Main Products Wood Gum Powder, Redispersible Latex Powder-Huzhou Yanbao New Building Materials Official Website',
product:'Huzhou Anbao building materials production wood gum powder, redispersable latex powder, woodworking gum powder, urea-formaldehyde resin gum powder is a new type of building materials adhesive products'
},
Copyright:{
key: '',
value:'No14020741 All Rights Reserved'
},
productnav:[
{
p1:"Latex powder",
url:"/home"
},
{
p1:"Can disperse latex powder again",
url:"/home"
},
{
p1:" Wood gum powder",
url:"http://www.hzjingbao.cn/index.html#/product/dtails/6"
},
{
p1:"Nethole polymer rubber powder",
url:"/home"
},
{
p1:"Urea resin rubber powder",
url:"http://www.hzjingbao.cn/index.html#/product/dtails/12"
},
{
p1:"Wood glue",
url:"http://www.hzjingbao.cn/index.html#/news/details/63"
},
{
p1:"Urea resin",
url:"/home"
},
{
p1:"Carpentry powder",
url:"http://www.hzjingbao.cn/index.html#/news/details/62"
}
]

}



//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 1